const ADD_ONS = (t, values, onChange) => [
  {
    name: 'integrationDriver',
    type: 'button',
    title: t('integrationDriver.title'),
    tag: t('integrationDriver.tag'),
    description: t('integrationDriver.description'),
    params: {
      colored: values && values.integrationDriver ? 'info' : 'white',
      disabled: !!(values && values.integrationDriver),
      children:
        values && values.integrationDriver
          ? t('integrationDriver.button.selectedText')
          : t('integrationDriver.button.text'),
      value: values ? values.integrationDriver || '' : '',
      fluid: true,
      onClick: onChange('integrationDriver', true)
    }
  },
  {
    name: 'dhis2SupportPlan',
    type: 'button',
    title: t('dhis2SupportPlan.title'),
    tag: t('dhis2SupportPlan.tag'),
    description: t('dhis2SupportPlan.description'),
    removeText: t('dhis2SupportPlan.remove'),
    params: {
      colored: values && values.dhis2SupportPlan ? 'info' : 'white',
      disabled: !!(values && values.dhis2SupportPlan),
      children:
        values && values.dhis2SupportPlan
          ? t('dhis2SupportPlan.button.selectedText')
          : t('dhis2SupportPlan.button.text'),
      value: values ? values.dhis2SupportPlan || '' : '',
      fluid: true,
      success: "true",
      onClick: onChange('dhis2SupportPlan', true)
    }
  },
  {
    name: 'specialRequirements',
    type: 'textArea',
    title: t('specialRequirements.title'),
    params: {
      textArea: true,
      value: values ? values.specialRequirements || '' : '',
      placeholder: t('specialRequirements.placeholder'),
      onChange: onChange('specialRequirements')
    }
  }
];

export { ADD_ONS };
